import React from "react";

type MenuDefinition = Record<string, Record<string, string>>;

interface SideBarProps {
  menu: MenuDefinition;
  active: string;
  setActive: (active: string) => void;
}

const SubMenuSideBar = ({ menu, active, setActive }: SideBarProps) => (
  <div className="col-3 bg-light p-0 b-r">
    {Object.entries(menu).map(([main, items]) => (
      <React.Fragment key={main}>
        <h4 className="p-3">{main}</h4>
        {Object.entries(items).map(([name, title]) => (
          <div key={name} className="list-group bg-light list-group-flush">
            <button
              className={`list-group-item list-group-item-action${
                active === name ? " active" : ""
              }`}
              onClick={() => setActive(name)}
            >
              {title}
            </button>
          </div>
        ))}
      </React.Fragment>
    ))}
  </div>
);

export default SubMenuSideBar;
